import { atomWithStorage } from "jotai/utils";
import { type UserEntityPreferredLanguage } from "@/api/__generated__/orval/auth";
import { DEFAULT_LANG } from "@/constants/languages.constants";
import { isSupportedLang } from "@/helpers/validators/isSupportedLang";

/**
 * Get initial language based on browser preference
 */
const getInitialBrowserLanguage =
  (): NonNullable<UserEntityPreferredLanguage> => {
    const browserLang = navigator.language.substring(0, 2).toLowerCase();

    if (isSupportedLang(browserLang)) {
      return browserLang;
    }

    return DEFAULT_LANG;
  };

/**
 * Atom for auth page language preference
 * Persisted in localStorage with key "kazaar_auth_language"
 * Initialized with browser language or fallback to English
 */
export const authLanguageAtom = atomWithStorage<
  NonNullable<UserEntityPreferredLanguage>
>("kazaar_auth_language", getInitialBrowserLanguage());
